import React from "react";
import Drawer from "react-modern-drawer";

function MainDrawer({ isOpen, toggleDrawer, children }) {
  return (
    <Drawer
      open={isOpen}
      onClose={toggleDrawer}
      direction="left"
      className="!bg-navy overflow-y-scroll scrollbar-thin"
    >
      {children}
    </Drawer>
  );
}

export default MainDrawer;
